import {
  levelChangeThresholdZoom,
  wheelTriggerR,
  getColorTemplate,
  menuDisabled,
  visualize,
  defaultText,
  slowSpeedCutoff,
  highSpeedCutoff,
  expectedSelectTimeSec,
  speedSmoothingCount,
  wheelCapR,
  breakR,
  wordBreakForTouchMap,
  wordBreakForTouch,
  enableSocket,
} from '../constants'
import { sendData } from '../data/sendData'
import { currentLevel, mapSpeedToMargeLevel } from '../scripts/mapping'
import { divideText, joinTextArray } from '../scripts/text'
import {
  includeSelected,
  getTextBlock,
  getTouchPosition,
  onTextNode,
  constrain,
  blockContainingNode,
  onControlsButton,
  touchBoundedBySelected,
  isEditTask,
  unique,
  mostMiddleNumber,
  arrLastN,
  includedByPseudo,
  blocksNotOverlapping,
  getColor,
  onBlockButNotTextNode,
  findNearbyTextNode,
  getTextBlockFromTarget,
  map,
  sumByItem,
  exists,
  canVibrate,
  customVibrate,
} from '../scripts/utils'
import {
  feedForwardHolder,
  setupWheel,
  pointAt,
  deHighlightHolders,
  hideToolWheel,
} from '../scripts/wheel'
import {
  getDynamicSeg,
  getPseudoSeg,
  getSegmentation,
  produceSegmentation,
} from '../segmentation/segmentation'
import FloatingControls from './FloatingControls'
import SemanticBlock from './SemanticBlock'
import SemanticMenu from './SemanticMenu'
import {
  _hub_exp_speedMapping,
  _hub_restore_touchPoints,
  _hub_scrolling,
  _hub_touchPoints,
  _hub_exp_thisTask,
} from './hub'
import { pickNextLevels, pickNextLevelsRecursive } from './nextLevels'
import NextButton from './tools/NextButton'
import { Slider } from '@material-ui/core'
import { withStyles } from '@material-ui/styles'
import log from 'log-here-now'
import p5 from 'p5'
import PropTypes from 'prop-types'
import React, { Component, createRef } from 'react'
import isEqual from 'react-fast-compare'

const PrettoSlider = withStyles({
  root: {
    color: '#52af77',
    height: 8,
  },
  thumb: {
    height: 24,
    width: 24,
    backgroundColor: '#fff',
    border: '2px solid currentColor',
    // marginTop: -8,
    // marginLeft: -12,
    '&:focus, &:hover, &$active': {
      boxShadow: 'inherit',
    },
  },
  active: {},
  valueLabel: {
    left: 'calc(-50% + 4px)',
  },
  track: {
    height: 8,
    borderRadius: 4,
  },
  rail: {
    height: 8,
    borderRadius: 4,
  },
})(Slider)

let pseudoChoices = null
export default class SemanticText extends Component {
  constructor(props) {
    super(props)

    this.colorTemplate = getColorTemplate()

    const _a = divideText(props.text)
    const _d = this.defaultSegmentation(_a)
    this.state = {
      textArray: _a, // Set on text change
      segmentation: _d, // Set on text change
      dynamicSegmentation: _d[0],
      focused: false,
      selectedNodeCount: null, // Node
      selectedBlockOrder: null, // Block
      inSelecting: false, // mousedown
      inRecognition: false,
      inRecognitionText: null,
      visualLevel: 0,
      /* -------------------------------------------------------------------------- */
      pseudoDynamicSegmentation: null,
      pseudoSegmentation: null,
      levelForMerge: null,
    }

    this._getSegmentation = this._gS.bind(this)
    this._getSegmentation() // Set on text change

    this.textRef = createRef()
    this.selectedBlockRef = createRef()

    this.onTextNode = null
    this.onTextBlock = null

    this.onTouchstart = this._touchstartListener.bind(this)
    this.onTouchmove = this._touchmoveListener.bind(this)
    this.onTouchend = this._touchendListener.bind(this)
    this.onStartRecognition = this.startRecognition.bind(this)
    this.onEndRecognition = this.endRecognition.bind(this)

    this.onScroll = this._scrollListener.bind(this)

    this.handleVisual = this._visual.bind(this)
    this.visualSlider = createRef()

    this.longPressTimeout = null
    this.aveSpeed = 0
  }

  componentDidMount() {
    document.addEventListener('touchstart', this.onTouchstart, {
      passive: false,
    })
    document.addEventListener('scroll', this.onScroll)
  }

  componentWillUnmount() {
    document.removeEventListener('touchstart', this.onTouchstart)
    document.removeEventListener('scroll', this.onScroll)
  }

  shouldComponentUpdate(prevProps, prevState) {
    return !isEqual(prevProps, this.props) || !isEqual(prevState, this.state)
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.text !== prevProps.text ||
      this.props.instruction !== prevProps.instruction ||
      this.props.refreshed !== prevProps.refreshed
    ) {
      const _a = divideText(this.props.text)
      const _d = this.defaultSegmentation(_a)

      this.setState(
        {
          textArray: _a,
          segmentation: _d,
          dynamicSegmentation: _d[0],
          selectedBlockOrder: null,
          selectedNodeCount: null,
          inRecognition: false,
          inRecognitionText: null,
        },
        () => {
          this._getSegmentation()
        }
      )
    }
  }

  async _gS() {
    const s = await getSegmentation(
      this.colorTemplate,
      this.props.text,
      this.state.textArray
    )
    this.setState({
      ...s,
    })
  }

  startRecognition(tempText) {
    this.setState({
      inRecognition: true,
      inRecognitionText: tempText,
    })
  }

  endRecognition() {
    this.setState({
      inRecognition: false,
      inRecognitionText: null,
    })
  }

  _visual(e) {
    if (e.target.value !== this.state.visualLevel) {
      this.setState({ visualLevel: e.target.value })
    }
  }

  /* -------------------------------------------------------------------------- */
  /*                             Merge segmentation                             */
  /* -------------------------------------------------------------------------- */

  getPseudoSelectionResults(maxLevel) {
    return pickNextLevelsRecursive(this.state, maxLevel, pseudoChoices)
  }

  segmentationFeedback(direction, speed, thisMag, mergeNow, dynamicDistance) {
    // if (_hub_touchPoints.aveSpeed <= slowSpeedCutoff) {
    //   // console.log('SLOW');
    //   targetSpeed = 1
    // } else if (_hub_touchPoints.aveSpeed > highSpeedCutoff) {
    //   // console.log('FAST');
    //   targetSpeed = 3
    // } else {
    //   // console.log('MID');
    //   targetSpeed = 2
    // }

    // DIRECTION
    const targetSide = direction === 2 ? 'after' : 'before'

    // MERGE COUNT AND LEVEL
    let targetMergePoint = pseudoChoices[targetSide][0]

    if (targetMergePoint && mergeNow) {
      // return this.segmentationMerge(direction, speed, targetMergePoint.level)
      _hub_touchPoints.mergedTimes++
      return this.countMerge(targetMergePoint.count, dynamicDistance)
    }

    //////////////////////////////////////////////////////////////////////////////
    /* -------------------------------------------------------------------------- */
    /*                                    VIS 1                                   */
    /* -------------------------------------------------------------------------- */
    // console.log(targetMergePoint, this.state.dynamicSegmentation[this.state.selectedBlockOrder]);
    if (
      targetMergePoint
      // && this.state.dynamicSegmentation[this.state.selectedBlockOrder]
    ) {
      targetMergePoint = targetMergePoint.count
      let startPoint, endPoint
      if (targetSide === 'before') {
        startPoint = targetMergePoint
        endPoint = this.getCurrentSelectionEnds()[0] - 1
      } else {
        startPoint = this.getCurrentSelectionEnds()[1] + 1
        endPoint = targetMergePoint
      }

      this.setState({
        pseudoSegmentation: getPseudoSeg(
          startPoint,
          endPoint,
          this.state.textArray,
          this.colorTemplate,
          thisMag,
          wordBreakForTouch
        ),
        levelForMerge: targetMergePoint.level,
      })
    } else {
      this.setState({
        pseudoDynamicSegmentation: null,
        pseudoSegmentation: null,
        levelForMerge: null,
      })
    }
    /* -------------------------------------------------------------------------- */
  }

  rewind(thisVec, thisMag) {
    // const totalDistance =
    //   sumByItem(_hub_touchPoints.dynamicMerges, 'dynamicDistance') - breakR

    const lastMerge =
      _hub_touchPoints.dynamicMerges[_hub_touchPoints.dynamicMerges.length - 1]

    const lastMergedVec = lastMerge.mergeVector
      .copy()
      .add(new p5.Vector(0, -breakR))
    const movedBackVec = lastMergedVec.sub(thisVec)

    let targetStart, targetEnd

    if (lastMerge.beforeStart === lastMerge.afterStart) {
      // rewind end
      targetStart = lastMerge.afterStart
      // const totalWordCanBeRewind = lastMerge.afterEnd - lastMerge.beforeEnd
      targetEnd =
        lastMerge.afterEnd -
        Math.floor(map(Math.abs(movedBackVec.y), 0, wordBreakForTouchMap, 0, 1))

      targetEnd = Math.max(targetStart, targetEnd)
    } else {
      // rewind start
      targetEnd = lastMerge.afterEnd
      // const totalWordCanBeRewind = lastMerge.beforeStart - lastMerge.afterStart
      targetStart =
        lastMerge.afterStart +
        Math.floor(map(Math.abs(movedBackVec.y), 0, wordBreakForTouchMap, 0, 1))

      targetStart = Math.min(targetStart, targetEnd)
    }

    let currentCount = Number(this.state.selectedNodeCount)
    let currentBlock = blockContainingNode(
      this.state.dynamicSegmentation,
      currentCount
    )
    targetEnd = Math.max(currentCount, targetEnd)
    targetStart = Math.min(currentCount, targetStart)
    if (
      targetStart === currentBlock.startCount &&
      targetEnd === currentBlock.endCount
    )
      return

    customVibrate(1)
    this.setState(prevState => {
      const newState = { ...prevState }

      let blockOrder
      ;[newState.dynamicSegmentation, blockOrder] = getDynamicSeg(
        targetStart,
        targetEnd,
        prevState.textArray,
        this.colorTemplate,
        prevState.textArray.length
      )

      // newState.selectedBlockOrder = blockOrder

      newState.pseudoDynamicSegmentation = null
      newState.pseudoSegmentation = null
      newState.levelForMerge = null

      sendData('selectionchange', null, {
        touchSpeed: 0,
        touchTarget: 'text',
        selectionArray: exists(blockOrder)
          ? newState.dynamicSegmentation[blockOrder].subArray
          : [],
        textArray: _hub_exp_thisTask.text,
      })

      return newState
    })
  }

  countMerge(targetCount, dynamicDistance) {
    customVibrate(5)

    this.setState(
      prevState => {
        const newState = { ...prevState }
        const { dynamicSegmentation } = prevState

        let currentCount = prevState.selectedNodeCount
        let currentBlock = blockContainingNode(
          dynamicSegmentation,
          currentCount
        )

        // Get start and end for the dynamic segmentation
        let targetStartCount, targetEndCount

        if (targetCount < currentBlock.startCount) {
          targetStartCount = targetCount
          targetEndCount = currentBlock.endCount
        } else {
          targetStartCount = currentBlock.startCount
          targetEndCount = targetCount
        }

        _hub_touchPoints.dynamicMerges.push({
          dynamicDistance: dynamicDistance,
          beforeStart: currentBlock.startCount,
          beforeEnd: currentBlock.endCount,
          afterStart: targetStartCount,
          afterEnd: targetEndCount,
          mergeVector: _hub_touchPoints.thisVector,
          mergeVectorY: _hub_touchPoints.thisVector.y,
        })

        let blockOrder
          // eslint-disable-next-line no-extra-semi
        ;[newState.dynamicSegmentation, blockOrder] = getDynamicSeg(
          targetStartCount,
          targetEndCount,
          prevState.textArray,
          this.colorTemplate,
          prevState.textArray.length
        )

        // newState.selectedBlockOrder = blockOrder

        newState.pseudoDynamicSegmentation = null
        newState.pseudoSegmentation = null
        newState.levelForMerge = null

        sendData('selectionchange', null, {
          touchSpeed: 0,
          touchTarget: 'text',
          selectionArray: exists(blockOrder)
            ? newState.dynamicSegmentation[blockOrder].subArray
            : [],
          textArray: _hub_exp_thisTask.text,
        })

        return newState
      },
      () => {
        this.offscreenSelect()
      }
    )
  }

  offscreenSelect() {
    if (
      this.selectedBlockRef.current &&
      this.selectedBlockRef.current.getBoundingClientRect().bottom >
        window.innerHeight - 25
    ) {
      this.selectedBlockRef.current.scrollIntoView({
        // behavior: 'smooth',
        block: 'end',
      })
      window.scrollBy(0, 25)
    }
  }

  segmentationMerge(direction, speed, levelForMerge) {
    // if (thisMag < wheelTriggerR)
    //   return

    // Remap speed to level for merge
    // let levelForMerge = mapSpeedToMargeLevel(
    //   // Need the current selection
    //   speed,
    //   Object.size(this.state.segmentation) - 1,
    //   _hub_exp_speedMapping.current
    // )

    // let levelForMerge = this.state.levelForMerge

    // Convert direction to expand direction
    let expandDirection =
      direction === 4 ? -1 : direction === 2 ? 1 : direction === 1 ? -2 : 2

    customVibrate(5)
    this.setState(prevState => {
      const newState = { ...prevState }
      const { segmentation, dynamicSegmentation } = prevState

      const seg = segmentation[levelForMerge]
      let currentCount = prevState.selectedNodeCount
      let currentBlock = blockContainingNode(dynamicSegmentation, currentCount)

      // Get start and end for the dynamic segmentation
      let targetStartCount = currentBlock.startCount
      let targetEndCount = currentBlock.endCount

      if (speed >= 0) {
        let targetLevelBlock = blockContainingNode(seg, currentCount)
        // Expand
        if (expandDirection < 0) {
          // Left (content before)
          ////
          while (
            targetLevelBlock.startCount > targetStartCount &&
            targetLevelBlock.order > 0
          )
            targetLevelBlock = seg[targetLevelBlock.order - 1]
          ////
          if (targetStartCount !== targetLevelBlock.startCount)
            targetStartCount = targetLevelBlock.startCount
          else
            targetStartCount =
              seg[
                constrain(targetLevelBlock.order - 1, 0, targetLevelBlock.order)
              ].startCount
        } else {
          // Right (content after)
          ////
          while (
            targetLevelBlock.endCount < targetEndCount &&
            targetLevelBlock.order < Object.size(seg) - 1
          )
            targetLevelBlock = seg[targetLevelBlock.order + 1]
          ////
          if (targetEndCount !== targetLevelBlock.endCount)
            targetEndCount = targetLevelBlock.endCount
          else
            targetEndCount =
              seg[
                constrain(
                  targetLevelBlock.order + 1,
                  targetLevelBlock.order,
                  Object.size(seg) - 1
                )
              ].endCount
        }
      } else {
        // Shrink
        if (expandDirection < 0) {
          // Content before
          let targetLevelBlockToRemove = blockContainingNode(
            seg,
            targetStartCount
          )
          targetStartCount = constrain(
            targetLevelBlockToRemove.endCount + 1,
            targetStartCount,
            currentCount
          )
        } else {
          // Content after
          let targetLevelBlockToRemove = blockContainingNode(
            seg,
            targetEndCount
          )
          while (!targetLevelBlockToRemove) {
            targetLevelBlockToRemove = blockContainingNode(
              seg,
              --targetEndCount
            )
          }
          targetEndCount = constrain(
            targetLevelBlockToRemove.startCount - 1,
            currentCount,
            targetEndCount
          )
        }
      }

      // eslint-disable-next-line no-extra-semi
      let blockOrder
      ;[newState.dynamicSegmentation, blockOrder] = getDynamicSeg(
        targetStartCount,
        targetEndCount,
        prevState.textArray,
        this.colorTemplate,
        prevState.textArray.length
      )

      // newState.selectedBlockOrder = blockOrder

      newState.pseudoDynamicSegmentation = null
      newState.pseudoSegmentation = null
      newState.levelForMerge = null

      return newState
    })
  }

  defaultSegmentation(textArray) {
    return produceSegmentation(
      {
        0: Array(textArray.length).fill(1),
        1: [textArray.length],
      },
      textArray,
      this.colorTemplate,
      textArray.length
    )
  }

  getCurrentSelectionEnds() {
    let currentCount = Number(this.state.selectedNodeCount)
    let currentBlock = blockContainingNode(
      this.state.dynamicSegmentation,
      currentCount
    )
    return [currentBlock.startCount, currentBlock.endCount]
  }

  /* -------------------------------------------------------------------------- */
  /*                                    Start                                   */
  /* -------------------------------------------------------------------------- */

  _touchstartListener(e) {
    if (visualize) return
    // ! MODE 1
    _hub_restore_touchPoints()

    if (_hub_scrolling.current) {
      _hub_scrolling.current = false
      return true
    }
    const onText = onTextNode(e, this.textRef.current)
    const onBlockButNotText = onBlockButNotTextNode(e, this.textRef.current)

    this.props.attachTouchendFunction(this.onTouchend)

    const touchStarted = () => {
      const { dynamicSegmentation, selectedBlockOrder } = this.state
      sendData('touchstart', e, {
        touchSpeed: 0,
        touchTarget: onText ? 'text' : 'noneText',
        selectionArray: exists(selectedBlockOrder)
          ? dynamicSegmentation[selectedBlockOrder].subArray
          : [],
        textArray: _hub_exp_thisTask.text,
      })
    }
    touchStarted()

    if (this.state.selectedBlockOrder !== null) {
      this._startTouch(e, onText, onBlockButNotText)
    } else {
      this.longPressTimeout = setTimeout(() => {
        if (onText || onBlockButNotText) {
          customVibrate(5)
        }
        this._startTouch(e, onText, onBlockButNotText)
      }, 500)
    }

    return false
  }

  _startTouch(e, onText, onBlockButNotText) {
    _hub_touchPoints._onTextOrAtLeastNotToClear = true

    let target = null

    if (
      onText ||
      onBlockButNotText ||
      (exists(this.state.selectedBlockOrder) &&
        touchBoundedBySelected(e, this.selectedBlockRef.current))
    ) {
      if (onText) target = e.target
      else target = findNearbyTextNode(e, this.selectedBlockRef.current)
    }

    ////
    // if (
    //   (onText ||
    //     (this.state.selectedBlockOrder &&
    //       touchBoundedBySelected(e, this.selectedBlockRef.current))) &&
    //   (this.onTextNode &&
    //   this.onTextBlock &&
    //   onText &&
    //   this.state.selectedBlockOrder
    //     ? blockContainingNode(
    //         this.state.dynamicSegmentation,
    //         Number(e.target.dataset.count)
    //       ).order === this.state.selectedBlockOrder
    //     : true)
    // ) {

    if (
      target &&
      (this.onTextNode &&
      this.onTextBlock &&
      exists(this.state.selectedBlockOrder)
        ? blockContainingNode(
            this.state.dynamicSegmentation,
            Number(target.dataset.count)
          ).order === this.state.selectedBlockOrder
        : true)
    ) {
      ////
      e.preventDefault()
      _hub_touchPoints._onTextOrAtLeastNotToClear = true

      this.onTextNode = target
      this.onTextBlock = getTextBlockFromTarget(target)

      const blockOrder = Number(this.onTextBlock.dataset.order)

      sendData('selectionchange', null, {
        touchSpeed: 0,
        touchTarget: 'text',
        selectionArray: exists(blockOrder)
          ? this.state.dynamicSegmentation[blockOrder].subArray
          : [],
        textArray: _hub_exp_thisTask.text,
      })

      this.setState({
        selectedNodeCount: Number(this.onTextNode.dataset.count),
        selectedBlockOrder: blockOrder,
        inSelecting: true,
        // dynamicSegmentation: this.state.segmentation[0],
      })

      const b = this.onTextBlock
      if (b !== null) {
        // const domRect = b.getBoundingClientRect()
        // _hub_touchPoints.start = _hub_touchPoints.now = boundingRectCenter(domRect)
        _hub_touchPoints.start = _hub_touchPoints.now = getTouchPosition(e)
        _hub_touchPoints.mode = 'init'

        // this.props.attachTouchmoveFunction(this.onTouchmove)

        // setupWheel(_hub_touchPoints.start)
      }
    } else if (
      !onControlsButton(e) &&
      !touchBoundedBySelected(e, this.selectedBlockRef.current)
    ) {
      _hub_touchPoints._onTextOrAtLeastNotToClear = false
      // this.setState({
      //   selectedNodeCount: null,
      //   selectedBlockOrder: null,
      //   dynamicSegmentation: this.state.segmentation[0],
      //   pseudoDynamicSegmentation: null,//
      //   pseudoSegmentation: null,//
      //   levelForMerge: null,//
      // })

      // this.onTextNode = null
      // this.onTextBlock = null

      // currentLevel.current = 0
    }

    this.props.attachTouchmoveFunction(this.onTouchmove)
  }

  /* -------------------------------------------------------------------------- */
  /*                                    Move                                    */
  /* -------------------------------------------------------------------------- */

  _touchmoveListener(e) {
    if (_hub_touchPoints._onTextOrAtLeastNotToClear) {
      if (e.cancelable) e.preventDefault()
      //
    } else {
      // _hub_touchPoints._onTextOrAtLeastNotToClear = true
      return
    }

    const t = _hub_touchPoints

    if (t.start) {
      t.now = getTouchPosition(e)
      let speed = 0

      const {
        now: [nX, nY],
        start: [sX, sY],
      } = t
      t.thisVector = new p5.Vector(nX - sX, nY - sY)
      t.thisStamp = performance.now()

      // let thisMag = t.thisVector.mag()
      let thisMag = Math.abs(t.thisVector.y)
      let thisMagStage = 0 // ?

      if (t.lastVector) {
        if (this.props.mode === 'touch') {
          // Display only after move a bit
          // if (thisMag > 10)
          //   displayToolWheel(document.querySelector('#tool-wheel'), t.start)
          // else hideToolWheel()

          speed =
            ((thisMag - t.lastVector.mag()) / (t.thisStamp - t.lastStamp)) *
            1000 // pix per sec
          // speed =
          //   t.thisVector.sub(t.lastVector).mag() / (t.thisStamp - t.lastStamp)

          const absSpeed = Math.abs(speed)
          t.speeds.push(absSpeed)

          t.aveSpeed =
            arrLastN(t.speeds, speedSmoothingCount).reduce((a, b) => a + b, 0) /
            arrLastN(t.speeds, speedSmoothingCount).length
          document.querySelector('.speed-vis').innerHTML =
            'SPEED ' + String(Math.round(t.aveSpeed))

          const lastMerge =
            _hub_touchPoints.dynamicMerges[
              _hub_touchPoints.dynamicMerges.length - 1
            ]
          const rewindBackAcrossInitTouchPoint = lastMerge
            ? lastMerge.mergeVectorY * _hub_touchPoints.thisVector.y < 0
            : false

          if (
            thisMag < sumByItem(t.dynamicMerges, 'dynamicDistance') - breakR ||
            rewindBackAcrossInitTouchPoint
          ) {
            this.rewind(t.thisVector, thisMag)
          } else {
            let thisMagToUse = thisMag
            thisMagToUse -= sumByItem(t.dynamicMerges, 'dynamicDistance')

            // eslint-disable-next-line no-unused-vars
            let [direction, angle, rawAngle] = pointAt(t.thisVector)

            this.segmentationFeedback(
              direction,
              speed,
              thisMagToUse,
              thisMagToUse > wordBreakForTouch,
              wordBreakForTouch
            )
            // this.segmentationMerge(
            //   direction,
            //   speed,
            //   thisMagStage,
            //   t.lastMagStage,
            //   thisMag
            // )

            // if (thisMag > wheelTriggerR) {
            //   // ! WHEEL
            //   if (direction === 2) {
            //     // Right
            //     feedForwardHolder('#icon-holder-right', thisMag, angle, speed)
            //   } else if (direction === 4) {
            //     // Left
            //     feedForwardHolder('#icon-holder-left', thisMag, angle, speed)
            //   }
            //   // !
            // } else {
            //   deHighlightHolders()
            // }
          }
        } else {
          let currentCount = this.state.selectedNodeCount
          let currentBlock = blockContainingNode(
            this.state.dynamicSegmentation,
            currentCount
          )
          const currentStart = currentBlock.startCount
          const currentEnd = currentBlock.endCount

          if (t._mapMode_initStart === null) {
            t._mapMode_initStart = currentStart
            t._mapMode_initEnd = currentEnd
          }

          let targetStart, targetEnd

          if (t.thisVector.y > 0) {
            // extend end
            targetEnd = Math.min(
              t._mapMode_initEnd +
                Math.max(
                  Math.floor(map(thisMag, 0, wordBreakForTouchMap, 0, 1)),
                  0
                ),
              this.state.textArray.length - 1
            )
            targetStart = t._mapMode_initStart
          } else {
            // extend start
            targetStart = Math.max(
              t._mapMode_initStart -
                Math.max(
                  Math.floor(map(thisMag, 0, wordBreakForTouchMap, 0, 1)),
                  0
                ),
              0
            )
            targetEnd = t._mapMode_initEnd
          }

          if (targetStart === currentStart && targetEnd === currentEnd) {
            // continue
          } else {
            customVibrate(5)
            this.setState(
              prevState => {
                const newState = { ...prevState }

                let blockOrder
                ;[newState.dynamicSegmentation, blockOrder] = getDynamicSeg(
                  targetStart,
                  targetEnd,
                  prevState.textArray,
                  this.colorTemplate,
                  prevState.textArray.length
                )

                newState.pseudoDynamicSegmentation = null
                newState.pseudoSegmentation = null
                newState.levelForMerge = null

                sendData('selectionchange', null, {
                  touchSpeed: 0,
                  touchTarget: 'text',
                  selectionArray: exists(blockOrder)
                    ? newState.dynamicSegmentation[blockOrder].subArray
                    : [],
                  textArray: _hub_exp_thisTask.text,
                })

                return newState
              },
              () => {
                this.offscreenSelect()
              }
            )
          }
        }
      }

      if (speed && enableSocket) {
        const { dynamicSegmentation } = this.state
        if (
          _hub_exp_thisTask.taskId &&
          !_hub_exp_thisTask.taskId.includes('edit')
        )
          sendData('touchmove', e, {
            touchSpeed: speed,
            touchTarget: 'text',
            selectionArray:
              dynamicSegmentation[this.onTextBlock.dataset.order].subArray,
            textArray: _hub_exp_thisTask.text,
          })
      }

      t.lastVector = t.thisVector.copy()
      t.lastStamp = t.thisStamp
      t.lastMagStage = thisMagStage
    }

    return false
  }

  /* -------------------------------------------------------------------------- */
  /*                                     End                                    */
  /* -------------------------------------------------------------------------- */

  _scrollListener() {
    if (this.longPressTimeout) {
      clearTimeout(this.longPressTimeout)
      this.longPressTimeout = null
    }
  }

  _touchendListener(e) {
    if (_hub_scrolling.current) return

    if (this.longPressTimeout) {
      clearTimeout(this.longPressTimeout)
      this.longPressTimeout = null
    }

    this.setState(prevState => {
      let newState = { ...prevState }
      newState.inSelecting = false
      let sE = this.textRef.current.querySelector('.selected')
      if (sE) {
        newState.selectedBlockOrder = Number(sE.dataset.order)
        this.onTextBlock = sE
      }
      newState.pseudoDynamicSegmentation = null
      newState.pseudoSegmentation = null
      newState.levelForMerge = null

      if (!_hub_touchPoints._onTextOrAtLeastNotToClear) {
        newState.selectedNodeCount = null
        newState.selectedBlockOrder = null
        newState.dynamicSegmentation = prevState.segmentation[0]

        this.onTextNode = null
        this.onTextBlock = null

        currentLevel.current = 0
      }

      return newState
    })

    _hub_restore_touchPoints()
    hideToolWheel()

    const { dynamicSegmentation } = this.state
    if (
      this.onTextBlock &&
      this.onTextBlock.dataset.order &&
      dynamicSegmentation[this.onTextBlock.dataset.order]
    ) {
      sendData('touchend', e, {
        touchSpeed: 0,
        touchTarget: 'text',
        selectionArray:
          dynamicSegmentation[this.onTextBlock.dataset.order].subArray,
        textArray: _hub_exp_thisTask.text,
      })
    }
  }

  render() {
    const {
      textArray,
      segmentation,
      dynamicSegmentation,
      focused,
      selectedNodeCount,
      inSelecting,
      inRecognition,
      inRecognitionText,
      visualLevel,
      pseudoDynamicSegmentation,
      pseudoSegmentation,
    } = this.state

    if (this.props.mode === 'touch')
      pseudoChoices = this.getPseudoSelectionResults(
        Object.size(this.state.segmentation) - 1,
        pseudoChoices
      )

    // let _segmentation = doHardCodeSegmentation
    //   ? produceSegmentation(
    //       example.lengthsLevels(textArray),
    //       this.colorTemplate,
    //       this.state.textArray.length
    //     )
    //   : segmentation

    const seg = visualize
      ? segmentation[visualLevel]
      : pseudoDynamicSegmentation
      ? pseudoDynamicSegmentation
      : dynamicSegmentation // !

    const blocks = []

    let selectedText = ''
    let selectedArray = []

    // Build each block

    for (let i in seg) {
      let subArray = textArray.slice(seg[i].startCount, seg[i].endCount + 1)
      // Is this block selected?
      let isSelected = includeSelected(
        seg[i].startCount,
        seg[i].length,
        selectedNodeCount
      )

      if (isSelected) {
        selectedText = joinTextArray(subArray)
        selectedArray = subArray
      }

      let key = ''
      if (isSelected) key = this.state.selectedBlockOrder
      else if (!isSelected && seg[i].order === this.state.selectedBlockOrder)
        key = 'unselected ' + seg[i].order
      else key = seg[i].order

      const inRec = isSelected && inRecognition && inRecognitionText

      if (pseudoSegmentation) {
        if (seg[i].startCount === pseudoSegmentation.startCount) {
          blocks.push(
            <SemanticBlock
              key={`${key} pseudo`}
              selectedRef={isSelected ? this.selectedBlockRef : null}
              startCount={pseudoSegmentation.startCount}
              order={seg[i].order}
              textSubArray={
                inRec
                  ? divideText(inRecognitionText)
                  : pseudoSegmentation.subArray
              }
              color={pseudoSegmentation.color}
              focused={focused || isSelected || visualize}
              selected={isSelected}
              pseudo={true}
              pseudoExpandSelectionResults={pseudoChoices}
              mode={this.props.mode}
            />
          )
          continue
        }
        let isPseudo = includedByPseudo(
          pseudoSegmentation.startCount,
          pseudoSegmentation.endCount,
          seg[i].startCount
        )
        if (isPseudo) continue
      }

      blocks.push(
        <SemanticBlock
          key={key + (seg[i].pseudo ? ' pseudos' : '')}
          selectedRef={isSelected ? this.selectedBlockRef : null}
          startCount={seg[i].startCount}
          order={Number(seg[i].order)}
          textSubArray={inRec ? divideText(inRecognitionText) : subArray}
          color={seg[i].color}
          focused={focused || isSelected || visualize}
          selected={isSelected}
          pseudo={false}
          dynamicPseudoBlock={seg[i].pseudo}
          pseudoExpandSelectionResults={pseudoChoices}
          mode={this.props.mode}
        />
      )
    }

    return (
      <div ref={this.textRef} className="semantic-text">
        {blocks}
        {!menuDisabled && (
          <SemanticMenu
            text={selectedText}
            inSelecting={inSelecting}
            blockRef={this.selectedBlockRef}
          />
        )}
        {isEditTask(_hub_exp_thisTask.taskId) && (
          <FloatingControls
            textArray={textArray}
            selectedArray={selectedArray}
            inSelecting={inSelecting}
            blockRef={this.selectedBlockRef}
            bodyChangeText={this.props.bodyChangeText}
            onStartRecognition={this.onStartRecognition}
            onEndRecognition={this.onEndRecognition}
          />
        )}
        {visualize && (
          <PrettoSlider
            ref={this.visualSlider}
            sx={{
              display: 'block',
              margin: '3rem auto 0',
              width: '80%',
            }}
            defaultValue={0}
            step={1}
            min={0}
            max={Object.size(this.state.segmentation) - 1}
            onChange={this.handleVisual}
            marks={true}
            valueLabelDisplay="auto"
            aria-labelledby="visualize-level"
          />
        )}
        {(isEditTask(_hub_exp_thisTask.taskId) || visualize) &&
          !defaultText && <NextButton selectedArray={selectedArray} />}
      </div>
    )
  }
}

SemanticText.propTypes = {
  text: PropTypes.string,
  instruction: PropTypes.string,
  attachTouchmoveFunction: PropTypes.func,
  attachTouchendFunction: PropTypes.func,
  bodyChangeText: PropTypes.func,
  mode: PropTypes.string,
  refreshed: PropTypes.number,
}
